module.exports = __webpack_public_path__ + "img/partner_banner1.048c27ef.png";